import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  EMITTER_ERROR,
  EMITTER_INFO,
  EMITTER_SUCCESS,
  EMITTER_WARNING,
  SNACKBAR_CONFIG as config,
} from "../utils/constants";
import CustomEventEmitter from "../utils/emitter/EventEmitter";
import { authRoutes } from "./authRoutes";
import { HOME_PATH } from "../utils/constants/routes";
import { Loading, InvalidRouteScreen } from "../screens";
import { SNACKBAR_CLOSE_ICON } from "../utils/constants/assets";
import { SnackbarCloseIcon } from "../components/Snackbar";

const Router = () => {

  const { enqueueSnackbar , closeSnackbar} = useSnackbar();

  useEffect(() => {

    CustomEventEmitter.on(EMITTER_SUCCESS, (message) => {
      enqueueSnackbar(message, {
        variant: "success",
        preventDuplicate: true,
        anchorOrigin: config.snackBarPlacement,
        action: (key) => ( <SnackbarCloseIcon src={ SNACKBAR_CLOSE_ICON } onClick={() => { closeSnackbar(key) }} /> ), 

      });
    });
    CustomEventEmitter.on(EMITTER_ERROR, (message) => {
      enqueueSnackbar(message, {
        variant: "error",
        preventDuplicate: true,
        anchorOrigin: config.snackBarPlacement,
        action: (key) => ( <SnackbarCloseIcon src={ SNACKBAR_CLOSE_ICON } onClick={() => { closeSnackbar(key) }} /> ), 

      });
    });
    CustomEventEmitter.on(EMITTER_INFO, (message) => {
      enqueueSnackbar(message, {
        variant: "info",
        preventDuplicate: true,
        anchorOrigin: config.snackBarPlacement,
      });
    });
    CustomEventEmitter.on(EMITTER_WARNING, (message) => {
      enqueueSnackbar(message, {
        variant: "warning",
        preventDuplicate: true,
        anchorOrigin: config.snackBarPlacement,
      });
    });
    //for alert messages - ends
    return () => {
      CustomEventEmitter.removeEventListener("alert_success");
      CustomEventEmitter.removeEventListener("alert_error");
      CustomEventEmitter.removeEventListener("alert_info");
      CustomEventEmitter.removeEventListener("alert_warning");
    };
  }, [enqueueSnackbar]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Base Route, starting of the application */}
        <Route path={HOME_PATH} element={<Loading />} />

        {/* All Auth routes  */}
        {authRoutes.map(({ path, component: Component }, index) => (
          <Route path={path} element={<Component />} key={index} exact />
        ))}

        <Route path="*" element={<InvalidRouteScreen />} />
      </Routes>
    </BrowserRouter>
  );
};
 
export default Router;
